import withStyles from "react-jss";
import React from "react";

const styles = () => ({
	root: {
		width: "100%",
		borderRadius: "10px",
	},
});

const Component = ({ classes, children }) => <div className={classes.root}>{children}</div>;

export default withStyles(styles)(Component);
